import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../../environments/environment";
import * as HSET from "../settings";
import { GenericHttpService } from "../../../../services/generic-http.service";

const month = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
@Injectable()
export class WarehouseUtlizationService {
  apiUrl = environment.gateWayHost;

  editItem: any;
  constructor(public generic: GenericHttpService) {}

  getWarehouseUtlization(url, params) {
    const option = {
      method: "GET",
      url: url,
      //url: url, // "./assets/data/p-d-otif.json",
      query: params
    };
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(this.processWarehouseUtlization.bind(this))
    );
  }

  processWarehouseUtlization(data: any) {
    if (data.data.length === 0) return null;
    const utilized = [],
      capacity = [];

    const processedData = this.drillDownData(
      data.data[0].WarehouseUtilizationV2
    );

    const __v2Data = processedData["data"];
    const dataKeys = processedData["dataKeys"];
    const allData = processedData["dataObject"];
    const allKey = processedData["allKey"];
    const chart1 = { utilized: allData["total_utilization_percent"], allKey, total: allData['total_volume'] };
    
    if (dataKeys.length) {
      dataKeys.map(_dataName => {
        
        
        utilized.push(
          Number(
            __v2Data[_dataName]["data"]["total_utilization_percent"].toFixed(2)
          )
        );
        capacity.push(
          Number(
            (__v2Data[_dataName]["data"]["total_volume"] / 1000).toFixed(0)
          )
        );
      });
    }
    const chart2 = { utilized, capacity, dataKeys };
    return { chart1, chart2 };
  }

  createChart(chartData, Options) {
    const chart1 = JSON.parse(JSON.stringify(HSET.chart1));
    const chart2 = JSON.parse(JSON.stringify(HSET.chart2));
    const available = [];
    chartData.chart2.utilized.forEach((element, index) => {
      available.push(
        // Number(((element * 100) / chartData.chart2.capacity[index]).toFixed(2))
        Number(Math.max(0, 100 - element).toFixed(2))
      );
    });
    chart1.tooltip.pointFormat="Utilized:"+  chartData.chart1.utilized.toFixed(2)+'%'+'<br/>'+'Total:' +chartData.chart1.total.toFixed(2)
    chart1.series[0].data = [chartData.chart1.utilized];
    chart2.series[0].data = available;
    chart2.series[1].data = chartData.chart2.utilized;
    chart2.series[2].data = chartData.chart2.capacity;

    chart1.xAxis.categories = [chartData.chart1.allKey];
    chart2.xAxis.categories = chartData.chart2["dataKeys"];

    return { chart1, chart2 };
  }

  drillDownData(data) {
    let dataKeys = [];
    let allKey = "All";
    let dataObject = { ...data["data"] };
    delete data["data"];

    if (Object.keys(data).length > 1) {
      dataKeys = Object.keys(data);
    } else if (Object.keys(data).length === 1) {
      allKey = Object.keys(data)[0];
      data = data[Object.keys(data)[0]];
      dataObject = { ...data["data"] };
      delete data["data"];
      if (Object.keys(data).length > 1) {
        dataKeys = Object.keys(data);
      } else if (Object.keys(data).length === 1) {
        allKey = Object.keys(data)[0];
        data = data[Object.keys(data)[0]];
        dataObject = { ...data["data"] };
        delete data["data"];
        dataKeys = Object.keys(data);
      }
    }
    return { data, dataKeys, dataObject, allKey };
  }
}
